import qs from "qs"

export function getWindowWidth (): number {
  return document.documentElement.offsetWidth
}

export function qsFromResultUrl(search?: string) {
  search = search || window.location.search
  if (search) {
    const obj = qs.parse(search, { ignoreQueryPrefix: true })
    if (obj.status) {
      const arr = obj.status.split('_')
      return Object.assign(obj, {
        status: arr[0],
        out_trade_no: arr[1],
        good_id: arr[2]
      })
    }
  }
  return {}
}

const Agents = ["Android", "iPhone",
  "SymbianOS", "Windows Phone",
  "iPad", "iPod", "Phone"]

export function isMobile () {
  return Agents.some(a => navigator.userAgent.includes(a))
}

export function toWindowBottom() {
  window.scrollTo(0, document.documentElement.clientHeight)
}
